import type { CustomFieldDefinition } from '@fukuri-admins/apis/client/gen/model';
import type { ClientsTable } from '../../presentations/ClientsTable';

type ColumnDef = NonNullable<
  React.ComponentProps<typeof ClientsTable>['customFieldColumns']
>[number];

/**
 * カスタムフィールド定義に基づいて、動的なカスタムフィールド列定義配列を構築する
 *
 * 固定列（会社名 / グループ / 取引店舗 / 担当者 / 契約プラン / 作成日時 / 更新日時 / 操作）は
 * Presentation 層（ClientsTable）でハードコードされる。
 * この関数はカスタムフィールド列のみを返す。
 *
 * Presentation 側で `[...fixedColumnsLeft, ...(customFieldColumns ?? []), ...fixedColumnsRight]`
 * として組み立てられる。
 *
 * @param customFieldDefinitions カスタムフィールド定義の配列
 * @returns カスタムフィールド列定義の配列
 */
export const buildCustomFieldColumns = (
  customFieldDefinitions: CustomFieldDefinition[]
): ColumnDef[] =>
  customFieldDefinitions.map(def => ({
    key: `custom_field_${def.label}`,
    label: def.label,
  }));
